import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=c9f7fa4c&scoped=true&"
import script from "./WarningIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WarningIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f7fa4c",
  null
  
)

export default component.exports